function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24.24c6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12s-12 5.373-12 12c0 6.628 5.373 12 12 12z",
  fill: "#2953E7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8 15.11c-.44.31-.98.48-1.62.48-1.37 0-2.34-.77-2.74-1.98h3.74v-.98h-3.93c-.01-.12-.01-.24-.01-.37 0-.14.01-.29.02-.42h3.92v-.98h-3.72c.4-1.19 1.34-1.98 2.71-1.98.59 0 1.09.15 1.51.41l.57-1.78c-.63-.31-1.37-.49-2.22-.49-2.48 0-4.23 1.57-4.75 3.84H7.2v.98h.92c-.02.16-.03.31-.03.47 0 .11.01.21.01.32h-.9v.98h1.03c.45 2.23 2.09 3.84 4.62 3.84.93 0 1.76-.2 2.47-.57l-.52-1.77z",
  fill: "#fff"
});

function SvgEur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "761dc7b990b5edd8d3eaf4c7c10511a5.svg";
export { SvgEur as ReactComponent };